import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from '@/shared/colors';
import vcolors from 'vuetify/lib/util/colors';
import en from 'vuetify/src/locale/en.ts';
import fr from 'vuetify/src/locale/fr.ts';
import es from 'vuetify/src/locale/es.ts';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: colors.skyBlue.base,
                secondary: colors.bramble.darken1,
                accent: colors.oceanBlue.base,
                error: vcolors.red.darken2,
                warning: vcolors.deepOrange.darken4,
                success: vcolors.green.darken3
            },
            dark: {
                primary: colors.deepBlue.base,
                secondary: colors.pumpkin.base,
                accent: colors.genesBlue.base,
                error: vcolors.red.accent1,
                warning: vcolors.orange.darken1,
                success: vcolors.green.base
            }
        }
    },
    icons: {
        iconFont: 'mdi'
    },
    lang: {
        locales: { en, es, fr }
    }
});
